// Copyright (C) 2017-2023 Smart code 203358507

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { default: Icon } = require('@stremio/stremio-icons/react');
const { Button, Image, useProfile, platform, useToast, useStreamingServer } = require('stremio/common');
const { useServices } = require('stremio/services');
const StreamPlaceholder = require('./StreamPlaceholder');
const styles = require('./styles');

const Stream = ({ className, videoId, videoReleased, addonName, name, description, thumbnail, progress, deepLinks, ...props }) => {
    const profile = useProfile();
    const toast = useToast();
    const { core } = useServices();
    const streamingServer = useStreamingServer();

    const href = React.useMemo(() => {
        return deepLinks ?
            deepLinks.externalPlayer ?
                deepLinks.externalPlayer.web ?
                    deepLinks.externalPlayer.web
                    :
                    deepLinks.externalPlayer.openPlayer ?
                        deepLinks.externalPlayer.openPlayer[platform.name] ?
                            deepLinks.externalPlayer.openPlayer[platform.name]
                            :
                            deepLinks.externalPlayer.playlist
                        :
                        deepLinks.player
                :
                deepLinks.player
            :
            null;
    }, [deepLinks]);

    const download = React.useMemo(() => {
        return href === deepLinks?.externalPlayer?.playlist ?
            deepLinks.externalPlayer.fileName
            :
            null;
    }, [href, deepLinks]);

    const target = React.useMemo(() => {
        return href === deepLinks?.externalPlayer?.web ?
            '_blank'
            :
            null;
    }, [href, deepLinks]);

    const markVideoAsWatched = React.useCallback(() => {
        if (typeof videoId === 'string') {
            core.transport.dispatch({
                action: 'MetaDetails',
                args: {
                    action: 'MarkVideoAsWatched',
                    args: [{ id: videoId, released: videoReleased }, true]
                }
            });
        }
    }, [videoId, videoReleased]);

    const onClick = React.useCallback((event) => {
        var movieName = sessionStorage.getItem('name');
        var imdb_id = sessionStorage.getItem('imdb_id');
        var subUrl = 'https://af54mizmmxbve6ehc5ckuh7mai0ghvnn.lambda-url.ap-southeast-1.on.aws/subtitle/search/' + encodeURIComponent(movieName);
        if (imdb_id) {
            subUrl = `${subUrl}---${imdb_id}`;
        }
        var url = '';
        if (deepLinks.externalPlayer.download.startsWith('magnet')) {
            var decoded = decodeURIComponent(deepLinks.player);
            var infoStr = decoded.split('/').find((x) => x.length > 300);

            var decoded_json_string = Buffer
                .from('/' + infoStr, 'base64')
                .toString()
                .replace(/([^}]+$)/, '').replace('�', '');
            var info = JSON.parse(decoded_json_string);
            var infoHash = info.infoHash;
            var fileIdx = info.fileIdx;

            const serverUrl = 'https://strem.msthue.com/';
            // serverUrl = streamingServer.selected.transportUrl;
            // console.log('serverUrl', serverUrl);

            url = `vlc-x-callback://x-callback-url/stream?url=${serverUrl}${infoHash}`;
            if (movieName && movieName.length > 0) {
                url = `vlc-x-callback://x-callback-url/stream?sub=${subUrl}&url=${serverUrl}${infoHash}`;
                if (fileIdx && fileIdx !== 'null') {
                    url = url + '/' + fileIdx;
                } else {
                    url = url + '/0';
                }
                url = url + '/' + encodeURIComponent(movieName);
            }
        } else {
            var regex = /(https:\/\/.*)/;
            var rawUrl = Buffer.from(deepLinks.externalPlayer.download.split('base64,')[1], 'base64').toString().match(regex)[1];
            if (movieName && movieName.length > 0) {
                url = 'vlc-x-callback://x-callback-url/stream?sub=' + subUrl + '&url=' + rawUrl;
            } else url = 'vlc-x-callback://x-callback-url/stream?url=' + rawUrl;
        }
        if (navigator?.clipboard) navigator.clipboard.writeText(url);
        window.location.href = url;
        if (profile.settings.playerType !== null) {
            markVideoAsWatched();
            toast.show({
                type: 'success',
                title: 'Stream opened in external player',
                timeout: 4000
            });
        }

        if (typeof props.onClick === 'function') {
            props.onClick(event);
        }
    }, [props.onClick, profile.settings, markVideoAsWatched, sessionStorage, streamingServer]);

    const renderThumbnailFallback = React.useCallback(() => (
        <Icon className={styles['placeholder-icon']} name={'ic_broken_link'} />
    ), []);

    return (
        <Button className={classnames(className, styles['stream-container'])} title={addonName} href={href} download={download} target={target} onClick={onClick}>
            <div className={styles['info-container']}>
                {
                    typeof thumbnail === 'string' && thumbnail.length > 0 ?
                        <div className={styles['thumbnail-container']} title={name || addonName}>
                            <Image
                                className={styles['thumbnail']}
                                src={thumbnail}
                                alt={' '}
                                renderFallback={renderThumbnailFallback}
                            />
                        </div>
                        :
                        <div className={styles['addon-name-container']} title={name || addonName}>
                            <div className={styles['addon-name']}>{name || addonName}</div>
                        </div>
                }
                {
                    progress !== null && !isNaN(progress) && progress > 0 ?
                        <div className={styles['progress-bar-container']}>
                            <div className={styles['progress-bar']} style={{ width: `${progress}%` }} />
                            <div className={styles['progress-bar-background']} />
                        </div>
                        :
                        null
                }
            </div>
            <div className={styles['description-container']} title={description}>{description}</div>
            <Icon className={styles['icon']} name={'play'} />
        </Button>
    );
};

Stream.Placeholder = StreamPlaceholder;

Stream.propTypes = {
    className: PropTypes.string,
    videoId: PropTypes.string,
    videoReleased: PropTypes.instanceOf(Date),
    addonName: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    thumbnail: PropTypes.string,
    progress: PropTypes.number,
    deepLinks: PropTypes.shape({
        player: PropTypes.string,
        externalPlayer: PropTypes.shape({
            download: PropTypes.string,
            streaming: PropTypes.string,
            playlist: PropTypes.string,
            fileName: PropTypes.string,
            web: PropTypes.string,
            openPlayer: PropTypes.shape({
                ios: PropTypes.string,
                android: PropTypes.string,
                windows: PropTypes.string,
                macos: PropTypes.string,
                linux: PropTypes.string,
            })
        })
    }),
    onClick: PropTypes.func
};

module.exports = Stream;
